/** Words the Announcements screens share (1.7.6): the groups line, an instant in New York time, a status's mark. */
import type { TFunction } from 'i18next';
import type { AnnouncementStatus, RecipientStatus } from '@shared/announcements';
import type { IconName } from '@/components/Icons';

/** "128 tenants · 41 volunteers · 6 extra" */
export const groupsLine = (t: TFunction, c: { tenants: number; volunteers: number; extra: number }) => [t('ann176.n.tenants', { count: c.tenants }), t('ann176.n.volunteers', { count: c.volunteers }), t('ann176.n.extra', { count: c.extra })].join(' · ');

/** An instant as the building reads the clock (America/New_York), like the Outbox. */
export const nyWhen = (iso: string | null, lang: string) => (iso ? new Intl.DateTimeFormat(lang === 'es' ? 'es-US' : 'en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZone: 'America/New_York' }).format(new Date(iso)) : '—');

/** Each status has a colour, a mark and its words — never the colour alone. */
export const ANNOUNCEMENT_MARK: Record<AnnouncementStatus, { cls: string; icon: IconName }> = {
  draft: { cls: 'prop', icon: 'pencil' },
  queued: { cls: 'sched', icon: 'clock' },
  sending: { cls: 'sched', icon: 'mail' },
  sent: { cls: 'conf', icon: 'check' },
  cancelled: { cls: 'hold', icon: 'x' },
};

export const RECIPIENT_MARK: Record<RecipientStatus, { cls: string; icon: IconName }> = {
  waiting: { cls: 'sched', icon: 'clock' },
  delivered: { cls: 'conf', icon: 'check' },
  failed: { cls: 'attn', icon: 'alert' },
  cancelled: { cls: 'hold', icon: 'x' },
  'left-out': { cls: 'hold', icon: 'pause' },
  'not-sent': { cls: 'attn', icon: 'alert' },
};
